import {
  anyAccountId,
  AnyAccountId,
  RoomContextId,
  roomContextId,
  RoomId,
  roomId
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomAccountDeleteCmd {
  private static validation = JsonSchemaValidator.compile(
    RoomAccountDeleteCmd.validationSchema()
  );

  constructor(readonly value: RoomAccountDeleteCmdRaw) {
    JsonSchemaValidator.assert(RoomAccountDeleteCmd.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["accountId", "roomId", "roomContextId"],
      properties: {
        accountId: anyAccountId,
        roomId,
        roomContextId
      },
      additionalProperties: false
    };
  }
}

interface RoomAccountDeleteCmdRaw {
  accountId: AnyAccountId;
  roomId: RoomId;
  roomContextId: RoomContextId;
}
